<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>

        <v-col class="pa-2" cols="12" md="4">
          <div class="sticky-md" style="top: 110px">
          
            <img :src="img" v-if="!!img" style="width: 100%; height: auto; justify-content: center; justify-self: center;"/>

            <v-card-actions class="justify-center">
              <div
                class="rowinfo"
                style="
                  justify-content: center !important;
                  align-items: center !important;
                "
              >
                <v-btn class="btn-download" @click="showDialog = true">
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-download`"
                  :help-data="helpData"
                  :service-name="serviceName"
                  class="buttoninfo"
                  label="دانلود کیوآر"
                  style="
                    padding: unset !important;
                    align-self: center !important;
                  "
                />
              </div>
            </v-card-actions>
          </div>
        </v-col>

        <v-col class="pa-3" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-content-start">
                <div class="col-md-12">
                  <p>ورود اطلاعات</p>
                </div>

                <div class="col-md-12 mt-0 pt-0">
                  <v-row>
                    <v-col cols="12" v-if="(cache===false && type_link==='order') || cache===true">                        
                          <v-alert  type="warning" border="left" color="warning" colored-border elevation="6" small>
                            <span v-if="cache">فعال شدن کش، سرعت انتقال کاربر به صفحه سرچ گوگل را کاهش میدهد.</span>
                            <span v-if="cache===false && type_link==='order'">در صورتی که کش غیرفعال باشد و حالت نمایش روی «ترتیبی» تنظیم شود، کاربران کلمات کلیدی تکراری مشاهده خواهند کرد.</span>
                          </v-alert>
                  </v-col>

                    <!-- فیلد نام کیوآر -->
                    <v-col cols="12" md="5" class="d-flex align-center">
                      <div class="rowinfo w-100 algin-items-start">
                        <v-text-field
                          v-model="visitName"
                          :disabled="e6 > 1"
                          append-icon="mdi-pen"
                          class="mt-0 pt-0 contentinfo w-100"
                          clear-icon="mdi-close-circle-outline"
                          clearable
                          dense
                          label="نام کیوآر"
                          outlined
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-visitName`"
                          :help-data="helpData"
                          :service-name="serviceName"
                          class="buttoninfo"
                          label="نام کیوآر"
                        />
                      </div>
                    </v-col>

<!-- فیلد نوع توزیع کلیدواژه -->
<v-col cols="12" md="4" class="d-flex align-center">
  <div class="rowinfo w-100 algin-items-start">
    <v-select
      v-model="type_link"
      :items="typeLinkOptions"
      dense
      outlined
      label="نحوه توزیع کلیدواژه‌ها"
      class="w-100 mt-0 pt-0 contentinfo"
    >
      <template v-slot:append-outer>
        <v-tooltip bottom max-width="320" color="white" content-class="elevation-10">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="info" small v-bind="attrs" v-on="on" style="margin-top: -4px;">
              mdi-help-circle-outline
            </v-icon>
          </template>
          <div class="text-right grey--text text--darken-3" style="line-height: 1.8; font-size: 13px;">
            <strong class="black--text">نحوه جستجوی کلیدواژه در گوگل:</strong><br />
            <!-- عناوین مشکی -->
            <span class="black--text font-weight-bold">۱. ترتیبی:</span> جستجو دقیقاً به همان ترتیبی که کلمات را وارد کرده‌اید انجام می‌شود.<br />
            <span class="black--text font-weight-bold">۲. تصادفی:</span> از بین کلمات لیست، کلمات به صورت کاملاً رندوم برای جستجو انتخاب می‌شود.<br />
            <span class="black--text font-weight-bold">۳. تصادفی درصدی:</span> کلمه کلیدی بر اساس درصدِ شانسی که برای آن تعیین کرده‌اید انتخاب و سرچ می‌شود.
          </div>
        </v-tooltip>
      </template>
    </v-select>

    <help-info
      :element-name="`${serviceName}-${componentName}-type_link`"
      :help-data="helpData"
      :service-name="serviceName"
      class="buttoninfo"
      label="نحوه توزیع"
    />
  </div>
</v-col>

                  <v-col cols="12" md="3" class="d-flex align-center">
                      <v-switch
                        v-model="cache"
                        dense
                        outlined
                        label="کش کردن IP جستجوگران"
                        class="w-100 mt-0 pt-0"
                        style="font-size: x-small;"
                      />
                    </v-col>

                  </v-row>
                </div>
              </div>
            </v-stepper-step>
            
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <list-expansion icon="bullseye-arrow" mandatory single title="کلیدواژه‌ها">
                <template v-slot:content>
                  
                  <div class="links-container pa-2">
                    
                    <!-- نمایش وضعیت درصدها -->
                  <v-alert
                    v-if="isPercentType"
                    dense
                    :type="totalPercent === 100 ? 'success' : totalPercent > 100 ? 'error' : 'warning'"
                    class="mb-4"
                    outlined
                  >
                    مجموع درصدها: <strong>{{ totalPercent }}٪</strong>
                    <span v-if="totalPercent > 100">
                      (خطا: مجموع درصدها <strong dir="ltr" style="display: inline-block;">{{ Math.abs(remainingPercent) }}٪</strong> بیشتر از ۱۰۰ است. لطفاً مقادیر را اصلاح کنید)
                    </span>
                    <span v-else-if="totalPercent < 100">
                      (مقدار <strong dir="ltr" style="display: inline-block;">{{ remainingPercent }}٪</strong> باقی‌مانده است)
                    </span>
                    <span v-else> (مجموع به درستی تنظیم شده است) </span>
                  </v-alert>
                    <v-card 
                        v-for="(item, index) in linkItems" 
                        :key="item.id"
                        class="mb-4 pa-3 elevation-1 rounded-lg"
                        outlined
                      >
                        <v-row>
                          <v-col cols="12" sm="12" md="12" class="pb-0">
                            <v-text-field
                              v-model="item.link"
                              :rules="[keyRules.checkKey]"
                              :append-icon="$vuetify.breakpoint.xsOnly ? '' : 'mdi-bullseye-arrow'"
                              clearable
                              dense
                              hide-details="auto"
                              hint="مثلاً: کمپین بهاره"
                              label="کلمه کلیدی"
                              outlined
                              placeholder="کلیدواژه موردنظر خود را وارد کنید"
                            />
                          </v-col>
                          
                              <v-col v-if="isPercentType" cols="12" sm="6" md="6" class="pb-0">
                                <v-text-field
                                  v-model="item.percent"
                                  type="number"
                                  dense
                                  max="100"
                                  min="1"
                                  :rules="percentRules"
                                  hide-details="auto"
                                  label="درصد نمایش"
                                  outlined
                                  placeholder="1 تا 100"
                                />
                              </v-col>                       
                             </v-row>

                        <v-row no-gutters align="center" class="mt-2">
                          <v-col class="pa-1 mt-2 mt-sm-0 d-flex justify-end align-center" cols="12">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon color="primary" :disabled="index === 0" v-bind="attrs" v-on="on" @click="moveUp(index)">
                                  <v-icon small>mdi-arrow-up</v-icon>
                                </v-btn>
                              </template>
                              <span>انتقال به بالا</span>
                            </v-tooltip>

                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon color="primary" :disabled="index === linkItems.length - 1" v-bind="attrs" v-on="on" @click="moveDown(index)">
                                  <v-icon small>mdi-arrow-down</v-icon>
                                </v-btn>
                              </template>
                              <span>انتقال به پایین</span>
                            </v-tooltip>

                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon color="error" v-bind="attrs" v-on="on" @click="removeLink(index)">
                                  <v-icon small>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <span>حذف کلیدواژه</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                  </v-card>

                    <v-btn
                      block
                      class="mt-2 btn-get-code rounded-lg"
                      :disabled="isPercentType && totalPercent >= 100"
                      @click="addLink"
                      @mousedown.prevent
                    >
                      <v-icon left>mdi-plus</v-icon>
                      افزودن کلید واژه جدید
                    </v-btn>
                  </div>
                  
                </template>
              </list-expansion>

              <div class="col-md-12 mt-4">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="qrUpdate"
                >
                  ویرایش کیوآر کلیک یار سئو 
                </next-btn>
              </div>
            </v-stepper-content>

            <div style="visibility: hidden">
              <qr-code-make
                ref="qrCanvas"
                v-model="qrDesign"
                :file.sync="qrSvgDataUrl"
                :link="previewLink"
                @save="qrDesign = $event"
              />
            </div>
          </v-stepper>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="{ title: 'دانلود کیوآر' }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-download-Qr-d`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>

          <v-card class="pa-5">
              <download-file-with-api
              v-if="showDialog"
              :address="`${data?.domain?.name||'qrland.in/'}${data.identifier}`"
              :visit-name="visitName"
              @close="showDialog = false"
              :qr_id="data?.qrId?.replace('?gateway=true','')"
              :is-qrlink="true"
            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
        <QrIntroModal v-if="$vuetify.breakpoint.mdAndUp"
      storageKey="clickyarseoEditIntroSeen"
      title="کیوآر کلیک یار سئو"
      :pro="true"
      icon="mdi-bullseye-arrow"
      iconColor="amber darken-2"
      :description="introText"
    />

  </help-info-wrapper>
</template>

<script>
import QrCodeMake from "../qrland/qrCodeStyle/qrCodeMake.vue";
import QrMaker from "../qrland/components/qrMaker.vue";
import ListExpansion from "../../content/fragments/listExpansion.vue";
import NextBtn from "../../content/fragments/nextBtn.vue";
import { debounce } from "../../../main.js";
import DownloadFileWithApi from "../qrland/downloadFileWithApi.vue";
import QrIntroModal from "../../pages/QrIntroModal.vue";

export default {
  name: "clickyarseoEdit",

  components: {
    NextBtn,
    ListExpansion,
    QrMaker,
    QrCodeMake,
    DownloadFileWithApi,
    QrIntroModal
  },

  data() {
    return {
      keyRules: {checkKey:(value)=>!!value ||'کلمه کلیدی باید انتخاب شود'},
      introText: `
        <strong>کیوآر کلیک یار سئو</strong> ابزاری هوشمند برای مدیریت و توزیع ترافیک روی کلیدواژه‌های مختلف است. شما می‌توانید چندین کلیدواژه را به لیست اضافه کنید تا کاربران از طریق جستجو در گوگل به سایت شما هدایت شوند.
        <br><br>
        <strong>چگونه کار می‌کند؟</strong> با هر بار اسکن شدن کیوآر کد، سیستم به صورت خودکار کاربران را به یکی از کلیدواژه‌های لیست شما هدایت می‌کند. شما می‌توانید نحوه توزیع این ترافیک را به یکی از سه روش زیر تنظیم کنید:
        <br><br>
        <span style="padding-right: 15px; display: block;">
          <strong>۱. ترتیبی:</strong> جستجو در گوگل دقیقاً به همان ترتیبی که کلمات را وارد کرده‌اید، به نوبت انجام می‌شود.<br>
          <strong>۲. تصادفی:</strong> در هر اسکن، یک کلیدواژه از بین لیست شما به صورت کاملاً تصادفی (رندوم) برای جستجو انتخاب می‌شود.<br>
          <strong>۳. تصادفی درصدی:</strong> هر کلیدواژه دقیقاً بر اساس درصدی (شانسی) که برای آن مشخص کرده‌اید انتخاب و سرچ می‌شود.
        </span>
        <br>
        این ویژگی برای <strong>کمپین‌های سئو</strong>، شبیه‌سازی رفتار طبیعی کاربر و توزیع دقیق ترافیک ارگانیک بسیار کاربردی است.
      `,
      helpData: [],
      serviceName: "Qrland",
      componentName: "clickyarseoedit",
      qrSvgDataUrl: "",
      showDialog: false,
      loading: false,
      e6: 1,
      visitName: "کلیک یار سئو",
      cache:false,
      type_link: "order",
      typeLinkOptions: [
        { text: 'ترتیبی', value: 'order' },
        { text: 'تصادفی', value: 'random' },
        { text: 'تصادفی درصدی', value: 'random_percent' }
      ],

      urlRules: {
        checkLink: (value) =>
          this.isURL(value) ||
          "کلیدواژه سایت باید بصورت http:// یا https:// وارد شود. ",
      },
      percentRules: [
          v => !!v || 'وارد کردن درصد الزامی است',
          v => (v > 0 && v <= 100) || 'درصد نمی‌تواند بیشتر از 100 باشد'
        ],
      img: null,
      identifier: null,
      linkItems: [],
      initiallinkItems: [],
      removedKeys: [],

      data: {
        identifier: "",
        qrId: null,
        domain: { name: "" }
      },
      qrDesign: null,
    };
  },

  computed: {
    domainName() {
      return this.$route.fullPath.replace(/\/qr\/linkpro\//g, "").replace('?gateway=true','');
    },
    previewLink() {
      const validLink = this.linkItems.find(item => item.link );
      return "https://qrland.in";
    },
    isPercentType() {
      return this.type_link === 'random_percent';
    },
    totalPercent() {
      return this.linkItems.reduce((sum, item) => sum + (Number(item.percent) || 0), 0);
    },
    remainingPercent() {
      return 100 - this.totalPercent;
    }
  },

  mounted() {
    this.fetchData();
  },

  watch: {
    previewLink(val) {
      debounce(() => {
        this.updateQr();
      }, 500);
    },
  },

  methods: {
    
   fetchData() {
  this.loading = true;
  this.$api
    .get(`/v1/testQr/find1/${this.domainName}`)
    .then(({ data }) => {
      const qrData = data.data; 
      const innerSettings = qrData.data || {};

      this.visitName = qrData.title;
      this.type_link = innerSettings.type || "order"; 
      
      this.data.identifier = qrData.identifier?.trim()?.replace(/https?:\/\/+/i, "");
      this.identifier = qrData.identifier?.trim()?.replace(/https?:\/\/+/i, "");
      this.qrDesign = qrData.qr;
      this.qrSvgDataUrl = qrData.image;
      this.data.qrId = qrData.id || qrData.qrId; 
      this.img = qrData.img_url;
      
      this.cache = innerSettings.cache || false; // آدرس درست برای فیلد کش

      const serverLinks = innerSettings.links || []; // آدرس درست برای دریافت آرایه لینک‌ها
      
      if (serverLinks && Array.isArray(serverLinks) && serverLinks.length > 0) {
        this.linkItems = serverLinks.map(item => {
          return {
            id: item.key || this.generateTempId(),
            key: item.key,
            link: item.link || "",
            percent: item.percent || null
          };
        });
        this.initiallinkItems = [...this.linkItems];
      } else {
        this.addLink();
      }
    })
    .finally(() => {
      this.loading = false;
      this.updateQr();
    });
},

    generateTempId() {
      return 'temp_' + Math.random().toString(36).substr(2, 9);
    },

    addLink() {
      if (this.linkItems.length >= 50) {
        this.$toast.error("حداکثر ۵۰ کلیدواژه می‌توانید اضافه کنید.");
        return;
      }
      
      // چک کردن مجموع درصد برای جلوگیری از اضافه شدن کلیدواژه جدید در ویرایش
      if (this.isPercentType && this.totalPercent >= 100) {
        this.$toast.error("مجموع درصدها به ۱۰۰ رسیده است یا از آن عبور کرده. لطفاً درصدها را اصلاح کنید.");
        return;
      }

      const hasEmpty = this.linkItems.some(item => !item.link || item.link.trim() === "");
      if (hasEmpty) {
        this.$toast.info("لطفاً ابتدا کلیدواژه‌های خالی را پر کنید.");
        return;
      }
      this.linkItems.push({
        id: this.generateTempId(),
        key: null,
        link: "",
        percent: null
      });
    },

    removeLink(index) {
      const item = this.linkItems[index];
      if (item.key) {
        this.removedKeys.push(item.key);
      }
      this.linkItems.splice(index, 1);
      
      if (this.linkItems.length === 0) {
        this.addLink();
      }
    },

    moveUp(index) {
      if (index > 0) {
        const item = this.linkItems.splice(index, 1)[0];
        this.linkItems.splice(index - 1, 0, item);
      }
    },

    moveDown(index) {
      if (index < this.linkItems.length - 1) {
        const item = this.linkItems.splice(index, 1)[0];
        this.linkItems.splice(index + 1, 0, item);
      }
    },

    validateAllLinks() {
      const links = [];
      let totalPercent = 0;
      
      for (let item of this.linkItems) {
        if (!item.link) {
          this.$toast.error(" تمامی کلیدواژه‌ها باید معتبر و با http/https باشد.");
          return false;
        }
        if (this.isPercentType) {
          totalPercent += Number(item.percent || 0);
        }
        links.push(item.link.trim());
      }
      
      if(new Set(links).size !== links.length) {
        this.$toast.error("کلیدواژه تکراری مجاز نیست. لطفاً بررسی کنید.");
        return false;
      }

      if (this.isPercentType && totalPercent !== 100) {
        this.$toast.error(`مجموع درصدها باید دقیقاً $100$ باشد. مقدار فعلی: ${totalPercent}`);
        return false;
      }
      
      return true;
    },

   qrUpdate() {
  if (!this.validateAllLinks()) return;

  this.loading = true;

  const formData = new FormData();
  formData.append("type", "clickyarseo");
  formData.append("qrType", "dynamic");
  formData.append("title", this.visitName);
  formData.append("_method", "PUT");
  formData.append("qr", JSON.stringify(this.qrDesign));
  formData.append("qr_id", this.domainName); 
  
  // اصلاح نام فیلدهای ارسالی مطابق پستمن
  formData.append("link_type", this.type_link); 
  formData.append("cache", this.cache ? 1 : 0); // تغییر catch به cache و ارسال مقدار 1/0

  this.linkItems.forEach((item, index) => {
    // جلوگیری از ارسال key برای آیتم‌های تازه ایجاد شده (بدون key معتبر)
    if (item.key && !String(item.id).startsWith('temp_')) {
      formData.append(`links[${index}][key]`, item.key);
    }
    formData.append(`links[${index}][link]`, item.link);
    // در پستمن مقدار خالی برای درصد ارسال شده بود
    formData.append(`links[${index}][percent]`, item.percent || ""); 
    formData.append(`order[]`, item.link);
  });
  
  this.$api
    .post("/v1/testQr/update", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => {
      this.$toast.success("کیوآر کلیدواژه شما باموفقیت ویرایش شد.");
      
      // اگر پاسخ بعد از آپدیت هم مشابه است، در صورت نیاز ساختار اینجا را هم آپدیت کنید
      if (res.data && res.data.data && res.data.data.data?.links) {
        this.removedKeys = [];
        this.linkItems = res.data.data.data.links.map(lData => ({
            id: lData.key,
            key: lData.key,
            link: lData.link,
            percent: lData.percent || null
        }));
        this.initiallinkItems = [...this.linkItems];
      }

      setTimeout(() => {
        this.$router.push(`/qr/list`);
      }, 500);
    })
    .catch((err) => {
       console.error(err);
    })
    .finally(() => {
      this.loading = false;
    });
},

    updateQr() {
      setTimeout(() => {
        if (this.$refs.qrCanvas && this.previewLink) {
          this.$refs.qrCanvas.appendCanvas(this.previewLink);
        }
      }, 500);
    },

    isURL(str) {
      if (!str) return false;
      try {
        const url = new URL(str);
        const res1 = url.protocol === "http:" || url.protocol === "https:";
        const regex = /^(https?:\/\/)([a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})+)[^\s]*$/;
        const res2 = regex.test(str.trim());
        return res2 && res1;
      } catch (err) {
        return false;
      }
    },
  },
};
</script>
